import React from "react";
import ReactTooltip from "react-tooltip";

type CardInfoType = {
  title: string;
  value: number;
  difference: number;
  sign?: string;
  tooltip?: string;
  negativeValueIsPositive?: boolean;
  showSymbol?: boolean;
};

type ListCardInfoType = {
  data: CardInfoType[];
};
const green = "[#65D5C5]";
const red = "[#FF6136]";
const bgGreen = "[#F0FBF9]";
const bgRed = "[#FFEFEB]";
export const CardInfo = ({
  title,
  value,
  difference,
  sign = "%",
  tooltip,
  negativeValueIsPositive,
  showSymbol = false,
}: CardInfoType) => {
  let color = difference > 0 ? green : red;
  let background = difference > 0 ? bgGreen : bgRed;
  if (negativeValueIsPositive) {
    color = difference < 0 ? green : red;
  }

  return (
    <div key={title} className="rounded border border-[#EAEBED] w-1/4 " data-tip data-for={title}>
      <ReactTooltip className="bg-red-500" id={title} place="top" effect="solid">
        {tooltip}
      </ReactTooltip>
      <div className="py-6 px-3 flex flex-col justify-center items-center h-full">
        <span className="text-[14px] font-semibold leading-[15px]"> {title} </span>
        <div className="flex justify-center items-center">
          <span className="text-[30px] mr-[16px] font-semibold"	> {value} </span>
          {difference !== 0 && (
            <span
              className={`text-[12px] p-1 bg-${background} text-${color} rounded h-[19px] d-flex align-items-center`}>
              {`${showSymbol && difference > 0 ? "+" : ""} ${difference} ${sign}`}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export const ListCardInfo = ({ data }: ListCardInfoType) => {
  return (
    <div className="flex flex-nowrap gap-x-5 ">
      {data.map((cardInfo: CardInfoType) => (
        <CardInfo key={cardInfo.title} {...cardInfo} />
      ))}
    </div>
  );
};
